import { ExchangeForm } from '@exodus/exchange-ui';

import { cn } from '@/ui/utils/classnames';
import type { SwapFormVariant } from '../types.js';
import { pickFirstTruthy } from '../utils.js';
import FlipButton, {
  DisabledHorizontalFlipButton,
  HorizontalFlipButton,
  DisabledVerticalFlipButton,
  VerticalFlipButton,
} from './flip-button.js';

type DividerProps = {
  variant: SwapFormVariant;
  disabled?: boolean;
};

function Divider({ variant, disabled }: DividerProps) {
  const isHorizontal = variant === 'horizontal';
  const isVertical = variant === 'vertical';

  return (
    <ExchangeForm.FlipButton
      Component={pickFirstTruthy(
        isHorizontal && disabled && DisabledHorizontalFlipButton,
        isHorizontal && HorizontalFlipButton,
        isVertical && disabled && DisabledVerticalFlipButton,
        isVertical && VerticalFlipButton,
      )}
      className={cn(
        isHorizontal && 'col-start-2 row-start-2',
        isVertical && 'col-span-2 col-start-1 row-start-3 my-4',
      )}
    />
  );
}

export function DividerSkeleton({ variant }: Pick<DividerProps, 'variant'>) {
  const isHorizontal = variant === 'horizontal';
  const isVertical = variant === 'vertical';

  return (
    <FlipButton
      variant={variant}
      className={cn(
        isHorizontal && 'col-start-2 row-start-2',
        isVertical && 'col-span-2 col-start-1 row-start-3 my-4',
      )}
      disabled
    />
  );
}

export default Divider;
